import { useStatsigClient } from '@statsig/react-bindings';
import { ComponentType } from 'react';

/** Send GA event data */
export function sendGAEvent(
  eventName: string,
  eventParams?: Record<string, string | boolean | number | null | undefined>,
) {
  if (window.gtag && typeof window.gtag === 'function') {
    window.gtag('event', eventName, eventParams);
  }
}

export type StatsigClientType = ReturnType<typeof useStatsigClient>;

/** Wrapper component for providing the Statsig client to class components */
export function withStatsigClient<P extends object>(
  WrappedComponent: ComponentType<P & { statsigClient: StatsigClientType }>,
) {
  return function WrapperComponent(props: P) {
    const statsigClient = useStatsigClient();
    return <WrappedComponent {...props} statsigClient={statsigClient} />;
  };
}
